export const unsplash = (id: string, w = 800, h?: number) => {
  const dims = h ? `w=${w}&h=${h}` : `w=${w}`
  return `https://images.unsplash.com/${id}?auto=format&fit=crop&${dims}&q=80`
}

export const imageIds = {
  hero: 'photo-1592945403244-b3fbafd7f539',
  bottle1: 'photo-1541643600914-78b084683601',
  bottle2: 'photo-1587017539504-67cfbddac569',
  bottle3: 'photo-1608528577891-eb055944f2e7',
  bottle4: 'photo-1590736704728-f4730bb30770',
  bottle5: 'photo-1588514912908-8f5891714f8d',
  bottle6: 'photo-1557170334-a9632e77c6e4',
  bottle7: 'photo-1504801019156-beabdea673be',
  bottle8: 'photo-1514348871858-1d3c20902571',
  texture1: 'photo-1543384490-fc38bd91de41',
  texture2: 'photo-1590502593747-42a996133562',
  texture3: 'photo-1487530811176-3780de880c2d',
  lifestyle1: 'photo-1561624485-0e43bcc1836d',
  lifestyle2: 'photo-1617172523785-eec3c7b0f6f5',
} as const
